<script setup lang="ts">
import type { IconValue } from '@/constants/menuLists.ts';

import listItemStyles from '@/styles/listItem.module.scss';

export interface Props {
  disabled?: boolean;
  prependIcon?: string | IconValue;
}
const props = withDefaults(defineProps<Props>(), {
  disabled: false,
  prependIcon: undefined,
});
</script>

<template>
  <v-list-item
    :prepend-icon="props.prependIcon"
    :disabled="props.disabled"
    :active-class="listItemStyles.listItemActive"
    :class="[
      $style.secondarySideBarMenuVListItem,
      listItemStyles.listItem,
      { [listItemStyles.listItemEnabled]: !props.disabled },
    ]"
    data-testid="secondarySideBarMenuVListItem"
  >
    <slot></slot>
    <template v-if="!props.prependIcon" #prepend
      ><slot name="prepend"></slot
    ></template>
  </v-list-item>
</template>

<!-- prettier-ignore -->
<style module lang="scss">
@use '@/styles/colors';
@use '@/styles/variables';

.secondarySideBarMenuVListItem {
}
</style>
